import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/payByParts-new-new';
import PayByPartsModel from '../models/payByParts.m';
import {apiback} from '../../../config';
import widgetsHelper from 'utils/getWidget.helper';

const paymentPart = 'payment_part';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            selectedType: paymentPart,
            model: {},
            isUtm: new URLSearchParams(this.props.location?.search).get('utm_source'),
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            utmParams: {},
            loader: true
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    componentWillMount() {
        this.widgetsHelper.getWidgets.call(this);
        this.getUrlParams();
        Promise.all([
            fetch(apiback('PAYMENT_PART')).then(res => res.json()),
            fetch(`${apiback('PAYMENT_PART_TERMS')}`).then(res => res.json())
        ]).then(response => {
            const [modelData, termsData] = response.map(item => item.data),
                {terms} = termsData,
                realRateList = response[0].data.real_yearly_bet,
                model = new PayByPartsModel(modelData[paymentPart], this.state.selectedType);

            model.setRealRateList(realRateList);
            model.setBankMonthCommission(terms);
            this.setState({model});
        });
        // .catch(x => console.log("error:", x)); todo добавить обработчик
    }

    getUrlParams() {
        const params = new URLSearchParams(window.location.search);
        let paramsObj = {};

        for (const [key, value] of params) {
            paramsObj[key] = value;
        }
        this.setState({utmParams: paramsObj});
    }

    static displayName = 'Credit.Views.PayByParts';

    static contextTypes = {
        app: PropTypes.object
    };
}
